import Instructions from './Instructions';
import { Box, CircularProgress, Container } from '@mui/material';
import ResolutionsContainer from './ResolutionsContainer';
import About from './About';
import { useResolutionsContext } from '../hooks/useResolutionsContext';
import { useErrorContext } from '../../global/hooks/useErrorContext';
import { Navigate } from 'react-router-dom';

//This component is responsible for displaying the resolutions content.
export default function ResolutionsContent() {
  const { selectedEvent, loading } = useResolutionsContext();
  const { error } = useErrorContext();

  if (error) {
    return (
      <Navigate to="/error" />
    );
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 1, color:"primary.dark" }}>
        <CircularProgress disableShrink size={25} />
      </Box>
    );
  }

  return (
    <Container>
      {selectedEvent && (
        <Box>
          <About />
          <Instructions />
          <ResolutionsContainer />
        </Box>
      )}
    </Container>
  );
}